export interface IConversation {
  id?: number;
  uuid?: string;
  messages?: Array<any>;
  read?: boolean;
  company?: Object | number;
  tracked_items?: Array<Object>;
  archived?: boolean;
  files?: Array<Object>;
  options?: Object;
}
export class Conversation implements IConversation {
  constructor({
    id = 0,
    uuid = "",
    messages = [],
    read = true,
    company = {},
    archived = false,
    tracked_items = [],
    files = [],
    options = {},
  }: {
    id?: number;
    uuid?: string;
    messages?: Array<any>;
    read?: boolean;
    company?: Object | number;
    tracked_items?: Array<Object>;
    archived?: boolean;
    files?: Array<Object>;
    options?: Object;
  } = {}) {
    this.id = id;
    this.uuid = uuid;
    this.messages = messages;
    this.read = read;
    this.company = company;
    this.tracked_items = tracked_items;
    this.archived = archived;
    this.files = files;
    this.options = options;
  }

  id?: number;
  uuid?: string;
  messages?: Array<any>;
  read?: boolean;
  company?: Object | number;
  tracked_items?: Array<Object>;
  archived?: boolean;
  files?: Array<Object>;
  options?: Object;
}

export class FileItem {
  tracked_items: Array<any>;
}
